import { Stack, Typography } from '@mui/material'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import DialogButton from '../../../Common/Buttons/DialogButton'
import Dialog from '../../../Common/Dialog/Dialog'
import DialogActions from '../../../Common/Dialog/DialogActions'
import DialogContent from '../../../Common/Dialog/DialogContent'
import DialogTitle from '../../../Common/Dialog/DialogTitle'
import { useAppDispatch } from '../../../Common/_hooks/useAppDispatch'
import { useAppSelector } from '../../../Common/_hooks/useAppSelector'
import { BatchIgnoreStoreProducts, type BatchStoreProductSelection } from '../../../UserData/_actions/Store/StoreProductActions'
import { ClearStoreSelectedProduct } from '../../../UIData/_actions/Account/AccountStoreActions'

interface Props {
  opened: boolean
  storeName: string
  storeType: string
  selection: BatchStoreProductSelection
  selectionCount: number
  onClose: () => void
}

export default function BatchIgnoreStoreProductsDialog(props: Props) {
  const [t] = useTranslation('account-v2')
  const dispatch = useAppDispatch()
  const loader = useAppSelector(state => state.get('UIData').get('loaders').get('edit_store_products'))

  const onConfirm = useCallback(() => {
    dispatch(BatchIgnoreStoreProducts(props.storeType, props.selection).set({
      onSuccess: () => {
        dispatch(ClearStoreSelectedProduct())
        props.onClose()
      }
    }))
  }, [dispatch, props])

  return <Dialog
    open={props.opened}
    maxWidth="xs"
    fullWidth
    onClose={props.onClose}
    showCloseButton
  >
    <DialogTitle>{t('Ignore {{count}} products', { count: props.selectionCount })}</DialogTitle>
    <DialogContent>
      <Stack spacing={2}>
        <Typography variant="body1">{t('This will automatically ignore all variants for the selected products when importing orders from your {{store}} store.', { store: props.storeName })}</Typography>
      </Stack>
    </DialogContent>
    <DialogActions>
      <DialogButton
        color="secondary"
        disabled={!!loader}
        onClick={props.onClose}
      >{t('Cancel')}</DialogButton>
      <DialogButton
        color="primary"
        disabled={!!loader}
        onClick={onConfirm}
        autoFocus
      >{t('Ignore')}</DialogButton>
    </DialogActions>
  </Dialog>
}
